import { Component, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { VesselsService } from '../../../../../services/vessels.service';
import { DatePipe } from '@angular/common';
import { StorageService } from '../../../../../services/storage.service';
import { OpenShipDetailModel, Setting, VesselDetails } from '../../../../../interface/fleetList.interface';
import { ToasterService } from 'src/app/services/toaster.service';

@Component({
  selector: 'app-ship-detail',
  templateUrl: './ship-detail.component.html',
  styleUrls: ['./ship-detail.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ShipDetailComponent {
  @Input() iShipDetail: any;
  @Input() vslNumber: any;
  @Input() subpool: any;
  @Input() owners: any;
  @Output() closeShipDetail = new EventEmitter();
  @Output() closeShip = new EventEmitter();

  
  setting:Setting  = {
    showCloseIcon: false, 
    backdropClick: false
  } 

  viewModel: OpenShipDetailModel  = {
    iAddPenaltyForm: false,
    iEditPenaltyForm: false ,
    iPenaltyForm: false,
    iEditShipForm: false,
    iConfirmModal: false,
    iStatusForm: false,
    loadListAfterShipDetailsClosed: false,
    tab: "particulars",
    confirmModalDescription: '',
    confirmModalTitle: '',
    revertAction: '',
    changeLogValue: '',
    statusLogActivity : {action: "", comment: "", createdAt: new Date(), effectiveDate: new Date(),reason: "", vslNumber: ""},
    selectedAttributes : { label: 'This month', value: 'cm' },
    changeLogsDurations: 
      [
        { label: 'This month', value: 'cm' },
        { label: 'Last 15 days', value: '15d' },
        { label: 'Last 30 days', value: '30d' },
        { label: 'Last 3 months', value: '3m' },
        { label: 'Last 5 months', value: '5m' },
        { label: 'Last 1 year', value: '1y' },
        { label: 'Last 3 years', value: '3y' },
        { label: 'Last 5 Years', value: '5y' },
      ],
      vesselChangeLogDetail:{logCount:0,wefPoolPoint:0},
      vesselChangeLogs:[],
  }
  shipDetail: VesselDetails[] | any;
  constructor(
    private _vesselService: VesselsService,
    public datepipe: DatePipe,
    private _storageService: StorageService,
    private toasterService: ToasterService,
  ) {
  }

  ngOnChanges() {
    this.getVesselDetail();
    this.viewModel.changeLogValue = this.viewModel.changeLogsDurations[0].value;
  }


  getVesselDetail() {
    this._vesselService.getVesselDetail(this.vslNumber)
      .subscribe({
        next: (res: any) => {
          if (res.data.getVessel.success) {
            this.shipDetail = {};
            this.shipDetail = res.data.getVessel.vessel;
            this.getVesselChangeLog();
            this.getChangeLogByAction();
          }
        }
      });
  }

  getVesselChangeLog() {
    let formData = { "vslNumber": this.shipDetail.vslNumber, "duration": this.viewModel.changeLogValue };
    this._vesselService.getVesselChangeLog(formData)
      .subscribe({
        next: (res) => {
          if (res.data.getVesselChangeLog.success) {
            this.viewModel.vesselChangeLogDetail = { logCount:res.data.getVesselChangeLog.logCount,wefPoolPoint:res.data.getVesselChangeLog.wefPoolPoint};
            this.viewModel.vesselChangeLogs = res.data.getVesselChangeLog.vesselChangeLog;
          }
        }
      });
  }

  getChangeLogByAction() {
    let formData = { "vslNumber": this.shipDetail.vslNumber, "action": 'status' };
    this._vesselService.getVesselChangeLogByAction(formData)
      .subscribe({
        next: (res) => {
          this.viewModel.statusLogActivity = res.data.getChangeLogLatestDataByAction.vesselChangeLog;
        }
      });
  }

 
  shipAction(action: any, shipDetail: any) {
    this.shipDetail = shipDetail;

    switch (action) {
      case 'add_penalty':
        this.viewModel.iPenaltyForm = true;
        this.viewModel.iAddPenaltyForm = true;
        this.viewModel.iEditPenaltyForm = false;
        break;

      case 'edit_penalty':
        this.viewModel.iPenaltyForm = true;
        this.viewModel.iEditPenaltyForm = true;
        this.viewModel.iAddPenaltyForm = false;
        break;

      case 'edit_ship':
        this.viewModel.iEditShipForm = true;
        break;

      case 'status':
        this.viewModel.iStatusForm = true;
        break;

      case 'revert_poolpoint':
        this.viewModel.confirmModalTitle = "Revert to Nominal Pool Points";
        this.viewModel.revertAction = "pool_point";
        this.viewModel.iConfirmModal = true;
        break;

      case 'revert_penalty':
        this.viewModel.confirmModalTitle = "Revert Penalty Changes";
        this.viewModel.revertAction = "penalty";
        this.viewModel.iConfirmModal = true;
        break;

      case 'revert_close_penalty':
        this.viewModel.confirmModalTitle = "Revert Close Penalty Changes";
        this.viewModel.revertAction = "closepenalty";
        this.viewModel.iConfirmModal = true;
        break;

      case 'revert_status':
        this.viewModel.confirmModalTitle = `Revert to ${shipDetail.updatedStatus == 'active' ? 'Inactive' : 'Active'} Status`;
        this.viewModel.revertAction = "status";
        this.viewModel.iConfirmModal = true;
        break;

        case 'delete_ship':
          this.viewModel.confirmModalTitle = "Revert Activation & Delete Ship";
          this.viewModel.confirmModalDescription = "The action will be reverted and chosen ship will be deleted from STJS Fleet";
          this.viewModel.revertAction = "delete";
          this.viewModel.iConfirmModal = true;
        break
      default:
        break;
    }
  }

  public closeMarkAsStatus(event) {
    this.viewModel.iStatusForm = false;
    this.refreshShipDetails();
  }

  public closeEditShip(event) {
    this.viewModel.iEditShipForm = false;
    setTimeout(() => {
      this.refreshShipDetails();
    }, 1000)
  }

  public closePenality(event) {
    this.viewModel.iPenaltyForm = false;
    this.viewModel.iEditPenaltyForm = false;
    this.viewModel.iAddPenaltyForm = false;
    this.refreshShipDetails();
  }

  refreshShipDetails() {
    if (this._storageService.getDataFromStorage("listReloadAction") == "yes") {
      this.viewModel.loadListAfterShipDetailsClosed = true;
      this.getVesselDetail();
      this._storageService.removeDataFromStorage("listReloadAction");
    }
  }

  public closePopup() {
    this.closeShipDetail.emit(this.viewModel.loadListAfterShipDetailsClosed);
  }

  changeDurations(event) {
    this.viewModel.changeLogValue = event.value;
    this.getVesselChangeLog();
  }

  public logAction() {
    return (this.viewModel.statusLogActivity['action'] == 'activated') ? 'active' : 'Inactive';
  }

  onAction(status: boolean) {
    this.viewModel.iConfirmModal = false;
    if (status) {
      switch (this.viewModel.revertAction) {
        case "pool_point":
          this.revertPoolPoints();
          break;
        case "penalty":
          this.revertPenalty();
          break;
        case "closepenalty":
          this.revertClosePenalty();
          break;
        case "status":
          this.revertStatus();
          break;
          case "delete":
          this.deleteShip();
          break;

        default:
          break;
      }
    }
    this.viewModel.revertAction = "";
  }


  deleteShip()
  {
    this._vesselService.deleteVessel(this.vslNumber)
      .subscribe({
        next: (res) => {
            if (res.data.deleteVessel.success){
              this.viewModel.loadListAfterShipDetailsClosed = true;
              this.closePopup();
              this.toasterService.openToast('Success', res.data.deleteVessel.message);
            }
        }
    });
  }
 

  revertPoolPoints() {
    this._vesselService.revertPoolPoints(this.vslNumber)
      .subscribe({
        next: (res) => {
          if (res.data.revertPoolPoints.success) {
            this.viewModel.loadListAfterShipDetailsClosed = true;
            this.getVesselDetail();
            this.toasterService.openToast('Success', res.data.revertPoolPoints.message);
          }
        }
      });
  }

  revertPenalty() {
    this._vesselService.revertPenalty(this.vslNumber)
      .subscribe({
        next: (res) => {
          if (res.data.revertPenalty.success) {
            this.viewModel.loadListAfterShipDetailsClosed = true;
            this.getVesselDetail();
            this.toasterService.openToast('Success', res.data.revertPenalty.message);
          }
        }
      });
  }

  revertClosePenalty() {
    this._vesselService.revertClosePenalty(this.vslNumber)
      .subscribe({
        next: (res) => {
          if (res.data.revertClosePenalty.success) {
            this.viewModel.loadListAfterShipDetailsClosed = true;
            this.getVesselDetail();
            this.toasterService.openToast('Success', res.data.revertClosePenalty.message);
          }
        }
      });
  }

  revertStatus() {
    this._vesselService.revertStatus(this.vslNumber)
      .subscribe({
        next: (res) => {
          if (res.data.revertStatus.success) {
            this.viewModel.loadListAfterShipDetailsClosed = true;
            this.getVesselDetail();
            this.toasterService.openToast('Success', res.data.revertStatus.message);
          }
        }
      });
  }

  checkEffectiveDate(effectiveDate: string, effectiveTime: string = '') {
    let effectiveDateUTCNumber;
    if (effectiveTime && effectiveTime != "" && effectiveTime != null) {
      let hours = Number(effectiveTime.split(":")[0]);
      let minutes = Number(effectiveTime.split(":")[1]);
      effectiveDateUTCNumber = new Date(effectiveDate).setUTCHours(hours, minutes, 0, 0);
    } else {
      effectiveDateUTCNumber = new Date(effectiveDate).setUTCHours(0, 0, 0, 0);
    }
    let todayUTCNumber = new Date(new Date().toUTCString()).getTime();
    return (effectiveDateUTCNumber <= todayUTCNumber) ? true : false;
  }

  public checkPoolPointEffectiveFrom(poolPointEffectiveFrom){
    let today = new Date(poolPointEffectiveFrom);
    let poolPointEffectivemilliseconds = today.getTime();
    let currentDate = new Date();
    let currentEffectivemilliseconds = currentDate.getTime();
    if(currentEffectivemilliseconds >= poolPointEffectivemilliseconds){
      return true;
    }
    return false;
  }

  clickOnDetailTab(tab: any) {
    this.viewModel.tab = tab;
  }

}
